import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  //   baseURL: "http://lvyou2.cc/index.php",
  baseURL: "",
  timeout: 15000 // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(

  config => {
    const expireTime = localStorage.getItem('token_expire');
    
    if (expireTime && Date.now() > Number(expireTime * 1000)) {
      
      localStorage.removeItem('token');
      localStorage.removeItem('token_expire');
    }
    config.headers['content-type'] = 'multipart/form-data'
    config.data['lang'] = localStorage.getItem('language') || 'en-US'
    config.data['token'] = localStorage.getItem('token') || ''
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  }

)

export default service